const categories = {
  dashboard: 'dashboard',
  providers: 'providers',
  transaction_search: 'transaction_search'
}

export default categories
